
import { defineComponent } from 'vue';
import { Button, IconButton, List, ListItem } from '@/ui/index';
import {  SessionController } from '@/controller/';
import { User, Employee, Company } from '@/model';
import store from '@/store/index';

export default defineComponent({
    name: "Profile",
    components: { Button, IconButton, List, ListItem  },
    mounted(){
        this.getSessionUser();
        this.getSessionCompany();
    },
    data(){
        return{
            store,
            sessionUser: {} as User,
            sessionEmployee: {} as Employee,
            sessionCompany: {} as Company
        }
    },
    computed: {
        employeeInitials() {
            const employee = this.sessionEmployee as Employee
            return employee?.firstName?.substr(0,1) + employee?.lastName?.substr(0,1)
        }        
    },
    methods: {
        getSessionUser() {
            this.sessionUser = SessionController.sessionUser;
            this.sessionEmployee = SessionController.sessionEmployee;
        },
        async getSessionCompany() {
            this.sessionCompany = await SessionController.getSessionCompany();
        },
        handleShowTimetables() {
            //console.log("TODO: Show timeTables")
        }
    },
})
